import { render, staticRenderFns } from "./WatchStreams.vue?vue&type=template&id=9774765e&scoped=true"
import script from "./WatchStreams.vue?vue&type=script&lang=js"
export * from "./WatchStreams.vue?vue&type=script&lang=js"
import style0 from "./WatchStreams.vue?vue&type=style&index=0&id=9774765e&prod&scoped=true&lang=css"
import style1 from "./WatchStreams.vue?vue&type=style&index=1&id=9774765e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9774765e",
  null
  
)

export default component.exports